/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const TrashEmpty140 = (props: SVGProps) => (
    <AccessibleSVG width={140} height={140} viewBox="0 0 140 140" {...props}>
        <g fill="none" fillRule="evenodd" transform="translate(32 15)">
            <path
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeWidth={2}
                d="M8.28 55.532c4.322 2.495 8.702 2.999 9.784 1.125 1.082-1.874-1.544-5.416-5.865-7.91-4.322-2.496-9.606-1.433-9.784-1.125-.178.308 1.544 5.415 5.866 7.91z"
            />
            <path
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeWidth={2}
                d="M9.035 60.88c4.99 0 9.035-1.755 9.035-3.919s-4.045-3.918-9.035-3.918S0 56.606 0 56.961c0 .356 4.045 3.918 9.035 3.918z"
            />
            <path
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M14.072 19.088h49.764c.917 0 1.643.676 1.62 1.505L63.88 77.859c-.023.831-.736 1.505-1.6 1.505H15.628c-.86 0-1.577-.677-1.6-1.505l-1.576-57.266c-.022-.832.7-1.505 1.62-1.505z"
            />
            <path
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M11.444 19.582c0-.828.681-1.5 1.497-1.5h52.422c.826 0 1.496.671 1.496 1.5v1.824c0 .828-.68 1.5-1.496 1.5H12.94a1.498 1.498 0 01-1.497-1.5v-1.824z"
            />
            <path
                fill={vars.bdlBoxBlue}
                d="M19 50a1 1 0 011 .99v4.02a.992.992 0 01-.883.983L19 56a1 1 0 01-1-.99v-4.02c0-.507.383-.926.883-.983L19 50zm0-16a1 1 0 011 .999V46a.996.996 0 01-.883.992L19 47a1 1 0 01-1-.999V35c0-.513.383-.935.883-.992L19 34zM51.077 3.769l.102.075c.426.358.482.993.127 1.415l-3.343 3.984a1 1 0 01-1.312.196l-.102-.076a1.006 1.006 0 01-.128-1.414l3.343-3.984a1 1 0 011.313-.196zm-24.239 0a1 1 0 011.313.196l3.343 3.984a1.006 1.006 0 01-.127 1.414l-.103.076a1 1 0 01-1.312-.196l-3.343-3.984a1.006 1.006 0 01.127-1.415zM38.958 0c.556 0 1.006.45 1.006 1.002v5.2a1 1 0 01-.888.995l-.118.007c-.556 0-1.007-.45-1.007-1.002v-5.2a1 1 0 01.889-.995L38.958 0z"
            />
            <path
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M66.257 60.88s-13.5 5.763-27.07 5.763-27.14-5.764-27.14-5.764 18.371 36.242 27.105 36.242c8.734 0 27.105-36.242 27.105-36.242z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillOpacity={0.07}
                d="M54.813 76.551s-5.788 4.13-10.595 4.13-5.213-3.045-9.545-3.045-10.58-1.085-10.58-1.085 11.294 17.587 15.36 17.587c4.066 0 15.36-17.587 15.36-17.587z"
            />
            <ellipse
                cx={39.152}
                cy={94.031}
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeWidth={2}
                rx={30.117}
                ry={8.439}
            />
            <path
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21.082 93.401c0 1.68 8.09 3.041 18.07 3.041s18.07-1.361 18.07-3.041-8.09-3.041-18.07-3.041"
            />
            <path
                stroke={vars.bdlBoxBlue}
                strokeDasharray={3.6}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M39.152 90.36c-9.98 0-18.07 1.361-18.07 3.041"
            />
            <path
                fill={vars.white}
                stroke={vars.bdlBoxBlue}
                strokeWidth={2}
                d="M38.321 104.168c-1.647-1.963-.263-6.333 2.898-9.993 2.845-3.295 6.272-5.222 9.545-2.452l18.84-16.244a.983.983 0 011.401.124l1.123 1.338a.982.982 0 01-.122 1.402L52.737 94.074c2.16 3.705-.332 6.746-4.071 8.976-4.154 2.476-8.697 3.081-10.345 1.118z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillOpacity={0.07}
                d="M43.41 93.996c2.021-1.902 4.467-2.454 6.725.237 2.251 2.683 1.251 4.977-.958 6.636-.25-.254 2.034-2.311-.54-5.379-2.574-3.067-5.02-1.247-5.228-1.494zm18.624-68.68c.336 0 .603.26.596.603l-.675 31.104c-.007.333-.116.348-.23.051 0 0-.73-1.672-.988-3.724-.259-2.051.22-1.493 0-7.967-.067-1.969-1.229-4.409-1.252-6.418-.043-3.633 1.255-7.513.778-9.843-.418-2.041-3.466 0-4.982-1.051-1.453-1.008-7.133-2.594-7.133-2.594-.311-.089-.302-.16.046-.16h13.84z"
            />
            <path
                stroke={vars.bdlBoxBlue}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21.708 70.236c-3.003 3.322-15.11 9.179-17.724 9.179-2.614 0 9.466-16.125 9.466-16.125m47.71 22.36c3.336 3.322 12.312-4.065 14.98-7.44 2.669-3.376-10.518-16.125-10.518-16.125"
            />
        </g>
    </AccessibleSVG>
);

export default TrashEmpty140;
